import { Cpu } from 'lucide-react';
import Select from '../ui/Select';

/** Dropdown to switch between available free models for a modality. */
export default function ModelSelector({ value, onChange, models, label = 'Model', disabled }) {
  return (
    <div>
      <div className="mb-1.5 flex items-center gap-1.5 text-xs font-medium uppercase tracking-wide text-content-subtle">
        <Cpu className="h-3.5 w-3.5" /> {label}
      </div>
      <Select value={value} onChange={onChange} options={models} disabled={disabled} />
    </div>
  );
}
